export default function getRequiredDocuments({ tipo, ubicacion_siniestro, subtipo_siniestro, valor_mercancia, t }) {
	if (tipo === "paqueteria") {
		return getPaqueteriaDocuments({ subtipo_siniestro, valor_mercancia, t });
	}

	if (tipo === "auto") {
		return getAutoDocuments({ subtipo_siniestro, t });
	}

	if (tipo === "contenedor") {
		return getContainerDocuments(t);
	}

	const baseDocuments = [
		{ key: "historial_gps", label: t('reportClaim.documents.gpsHistory'), required: true },
		{ key: "salida_almacen", label: t('reportClaim.documents.warehouseExit'), required: true },
		{ key: "factura_compra", label: t('reportClaim.documents.purchaseInvoice'), required: true },
		{ key: "licencia_conductor", label: t('reportClaim.documents.driverLicense'), required: true },
		{ key: "tarjeta_circulacion", label: t('reportClaim.documents.vehicleRegistration'), notes: t('reportClaim.documents.vehicleRegistrationNotes'), required: true },
		{ key: "carta_porte", label: t('reportClaim.documents.cartaPorteDefault'), required: true },
		{ key: "declaracion_mp", label: t('reportClaim.documents.mpDeclaration'), required: true },
		{ key: "carta_reclamacion_chubb", label: t('reportClaim.documents.chubbClaim'), templateUrl: "plantilla_reclamacion_chubb.docx", required: true },
		{ key: "carta_reclamacion_transportista", label: t('reportClaim.documents.carrierClaim'), templateUrl: "plantilla_reclamacion_transportista.docx", required: true },
	];

	let docs = [...baseDocuments];

	if (tipo === "domestic" && ubicacion_siniestro === "ferrocarril") {
		docs = docs.filter(d => !["historial_gps", "licencia_conductor", "tarjeta_circulacion"].includes(d.key));
		docs = docs.map(d => {
			if (d.key === "carta_porte") return { ...d, label: t('reportClaim.documents.cartaPorteRailroad') };
			return d;
		});
		docs.push(
			{ key: "confronta_ferrocarril", label: t('reportClaim.documents.railroadConfrontation'), required: true },
			{ key: "carta_reclamacion_ferrocarril", label: t('reportClaim.documents.railroadClaim'), required: true },
		);
	}

	if (tipo === "crossborder") {
		docs = docs.map(d => {
			if (d.key === "carta_porte") return { ...d, label: t('reportClaim.documents.cartaPorteCrossborder') };
			if (d.key === "declaracion_mp") return { ...d, label: t('reportClaim.documents.mpPoliceReport') };
			return d;
		});
	}

	if (tipo === "maritime" && ubicacion_siniestro === "agua") {
		docs = docs.map(d => {
			if (d.key === "carta_porte") return { ...d, label: t('reportClaim.documents.cartaPorteMaritime') };
			return d;
		});
	}

	return docs;
}

// Ramo auto: documentos definidos en `helpers/siniestroRequiredDocuments.js` del backend.
function getAutoDocuments({ subtipo_siniestro, t }) {
	const docs = [
		{ key: "parte_ajustador", label: t('reportClaim.documents.adjusterReport'), required: true },
		{ key: "identificacion_asegurado", label: t('reportClaim.documents.insuredId'), required: true },
		{ key: "licencia_conductor", label: t('reportClaim.documents.driverLicense'), required: true },
		{ key: "tarjeta_circulacion", label: t('reportClaim.documents.vehicleRegistration'), required: true },
		{ key: "fotos_dano", label: t('reportClaim.documents.damagePhotos'), required: true },
		{ key: "factura_vehiculo", label: t('reportClaim.documents.vehicleInvoice'), required: true },
	];

	if (["robo_total", "robo_parcial"].includes(subtipo_siniestro)) {
		docs.push({ key: "denuncia_robo", label: t('reportClaim.documents.theftReport'), required: true });
	}

	return docs;
}

function getContainerDocuments(t) {
	return [
		{ key: "carta_reclamacion_chubb", label: t('reportClaim.documents.chubbClaim'), templateUrl: "plantilla_reclamacion_chubb.docx", required: true },
		{ key: "declaracion_mp", label: t('reportClaim.documents.mpDeclaration'), required: true },
		{ key: "carta_cobro_naviera", label: t('reportClaim.documents.shippingLineChargeLetter'), required: true },
		{ key: "licencia_conductor", label: t('reportClaim.documents.driverLicense'), required: true },
		{ key: "tarjeta_circulacion", label: t('reportClaim.documents.vehicleRegistration'), notes: t('reportClaim.documents.vehicleRegistrationNotes'), required: true },
		{ key: "carta_porte", label: t('reportClaim.documents.cartaPorteDefault'), required: true },
		{ key: "historial_gps", label: t('reportClaim.documents.gpsHistory'), required: true },
	];
}

function getPaqueteriaDocuments({ subtipo_siniestro, valor_mercancia, t }) {
	const docs = [
		{ key: "factura_valor", label: t('reportClaim.documents.valueInvoice'), required: true },
	];

	if (valor_mercancia > 5000) {
		docs.push({ key: "foto_producto", label: t('reportClaim.documents.productPhoto'), required: true });
	}

	if (subtipo_siniestro === "perdida_robo") {
		docs.push({ key: "evidencia_paqueteria", label: t('reportClaim.documents.parcelEvidence'), required: true });
	}

	if (subtipo_siniestro === "daño") {
		docs.push(
			{ key: "firma_recepcion", label: t('reportClaim.documents.receptionSignature'), required: true },
			{ key: "fotos_dano", label: t('reportClaim.documents.damagePhotos'), required: true },
		);
		if (valor_mercancia > 5000) {
			docs.push({ key: "cotizacion_reparacion", label: t('reportClaim.documents.repairQuotation'), required: true });
		}
	}

	return docs;
}
